<template>
  <div class="yx-bdqk-page main-layout">
    <CCollapseItem>
      <template slot="title-left"> 现场迎新管理 </template>
      <template slot="body">
        <c-search
          v-model="pageParams"
          :searchItems="searchItems"
          @reset="refresh"
          @search="pageGet(true)"
        >
        </c-search>
      </template>
    </CCollapseItem>
    <el-card class="box-table box-bottom">
      <div slot="header" class="btn-group">
        <!-- 操作按钮 -->
        <div class="btn-left">
          <!-- <el-button type="primary" plain>导出</el-button> -->
        </div>
        <!-- 右侧操作按钮 -->
        <table-btns
          :tableColumns="tableColumns"
          @tableColumnsChange="tableColumnsChange"
          @refresh="
            idList = [];
            pageGet(true);
          "
        ></table-btns>
      </div>
      <c-table
        :data="pageData"
        :tableColumns="tableColumns"
        :pagination="pageParams"
        @change="pageGet"
        @selectionChange="selectionChange"
        v-loading="pageLoading"
      >
      </c-table>
    </el-card>
  </div>
</template>

<script>
import MPage from "@/mixins/MPage.js";
import Configs from "./data/bdqk";
import { getOrgOptions } from "@/libs/searchSelect.js";
import { mapState } from "vuex";
let mPage = MPage({
  pagePath: "/welcome-live/statistics/allLinkListPage",
  pageDelPath: "",
  pageDelsPath: "",
  pageParams: {
    collegeId: "",
    grade: "",
    majorId: "",
    classId: "",
    classIdList: [],
    academicDegree: "",
    academicYear: "",
    studentNoOrName: "",
    sex: "",
    idCard: "",
    phoneNumber: "",
    isComplete: "",
    noCompleteLinkIdList: [],
  },
});
export default {
  mixins: [mPage],
  data() {
    let { searchItems, tableColumns } = Configs(this);
    return {
      isFold: false,
      searchItems,
      tableColumns,
      idList: [],
    };
  },
  computed: {
    ...mapState("dic", [
      "SUCCESS_CODE",
      "_CURRENTYEAR",
      "_COLLEGE_ID",
      "_CURRENT_ACADEMIC",
    ]),
  },
  created() {
    this.setCollegeId();
    this.getColumns();
  },
  mounted() {},
  methods: {
    setCollegeId() {
      if (this._COLLEGE_ID) {
        this.pageParams.collegeId = this._COLLEGE_ID;
        getOrgOptions(
          this,
          { parentId: this._COLLEGE_ID, type: "department" },
          1,
          null
        );
      }
    },
    //获取表头
    getColumns() {
      this.$http
        .get(
          "/welcome-live/statistics/getLinkList?collegeId=" +
            this.pageParams.collegeId
        )
        .then((res) => {
          console.log(res);
          if (res.code == this.SUCCESS_CODE) {
            this.tableColumns.splice(7);
            this.searchItems[this.searchItems.length - 1].options = [];
            res.data.forEach((item) => {
              this.tableColumns.push({
                label: item.linkName,
                prop: "map." + item.id,
                align: "center",
                show: true,
                minWidth: 140,
              });
              this.searchItems[this.searchItems.length - 1].options.push({
                label: item.linkName,
                value: item.id,
              });
            });
          } else {
            this.$message.error(`${res.msg}`);
          }
        });
    },
    selectionChange(data) {
      let idList = [];
      if (data.length) {
        data.forEach((item) => {
          idList.push(item.id);
        });
        this.idList = idList;
      }
    },
    handleDelBatch() {
      if (this.idList.length) {
        this.pageDels(this.idList);
      } else {
        this.$message({
          message: "请选择需要删除的数据！",
          type: "warning",
        });
      }
    },
    pageDelAfterFn() {
      this.idList = [];
      this.pageGet(true);
    },
    search() {
      this.pageGet(true);
      this.getColumns();
    },
    pageGetBeforeFn(data) {
      let params = Object.assign({}, data);
      if (!params.academicDegree)
        params.academicDegree = this._CURRENT_ACADEMIC;
      params.enrollmentYear = this._CURRENTYEAR[0].value;
      params.classId = params.classIdList.join(",");
      delete params.classIdList;
      params.noCompleteLinkId = params.noCompleteLinkIdList.join(",");
      delete params.noCompleteLinkIdList;
      return params;
    },
    refresh() {
      this.idList = [];
      this.searchItems[2].options = [];
      this.searchItems[3].options = [];
      this.pageParams = {
        collegeId: "",
        grade: "",
        majorId: "",
        classId: "",
        classIdList: [],
        academicDegree: "",
        academicYear: "",
        studentNoOrName: "",
        sex: "",
        idCard: "",
        phoneNumber: "",
        isComplete: "",
        noCompleteLinkIdList: [],
      };
      this.setCollegeId();
      this.pageGet(true);
      this.getColumns();
    },
    tableColumnsChange(data) {
      let self = this;
      self.tableColumns.forEach((item) => {
        if (data.indexOf(item.prop) == -1) {
          item.show = false;
        } else {
          item.show = true;
        }
      });
    },
  },
};
</script>
